module.exports = __webpack_public_path__ + "static/media/blogs_image_.058eca4c.svg";